import { render, staticRenderFns } from "./script-content.component.vue?vue&type=template&id=8f3547b2&scoped=true&"
import script from "./script-content.component.vue?vue&type=script&lang=ts&"
export * from "./script-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./script-content.component.vue?vue&type=style&index=0&id=8f3547b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3547b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VForm,VIcon,VSelect,VTextField,VTextarea})
